export const menuItems = [
  { text: 'Dashboard', routeName: 'dashboard', icon: 'fas fa-tachometer-alt'},
  // { text: 'Create Job', routeName: 'job.create', icon: 'fas fa-plus' },
  { text: 'Jobs hub', routeName: 'user.jobs', icon: 'fas fa-briefcase' },
  // { text: 'Public Jobs', routeName: 'jobsearch', icon: 'fas fa-briefcase' },
  { text: 'Profile hub', routeName: 'profile.hub', icon: 'fas fa-users' },
  { text: 'Connections', routeName: 'connections', icon: 'fas fa-handshake' },
  { text: 'Messages', routeName: 'messaging', icon: 'fas fa-envelope' },
  { text: 'Calendar', routeName: 'calendar', icon: 'fas fa-calendar-alt' },
  { text: 'Edit Profile', href: '/user/profile', icon: 'fas fa-edit' },
  { text: 'User Guide', href: '/userguide', icon: 'fas fa-book' }
];
